import React from "react";
import classnames from "classnames";
import styled from "styled-components";
import styles from "./PromotionItem.scss";

const Container = styled.div`
  height: 24px;
  width: 24px;
`;

function removeIconSetIdentifier(iconName) {
  return iconName && iconName.split("/")[1];
}

const Icon = ({ iconName, iconBlack }) => (
  <Container className={classnames("wbkv9-PromotionItem-icon", iconBlack ? styles.iconBlack : "")}>
    <i className="material-icons">{removeIconSetIdentifier(iconName)}</i>
  </Container>
);

export default Icon;
